<template>
  <transition name="slide" @enter="enter" @leave="leave" @after-enter="afterEnter">
    <div class="string" v-if="isShow">
      <div class="additional-info fields custom">
        <div class="order-input contact-name">
          <input
            type="text"
            :placeholder="`Имя ${getDotIndex(dot) ? 'получателя' : 'отправителя'}`"
            v-model="contact"
          />
        </div>
        <div class="order-input comment">
          <AdaptiveTextArea
            ref="commentField"
            class="textarea-comment"
            :placeholder="`Комментарий к адресу`"
            v-model="comment"
          />
          <i
            v-if="comment"
            @click="removeComment"
            @keypress="removeComment"
            v-tooltip.top-center="{
              content: 'Очистить поле',
              trigger: 'hover click',
            }"
            class="icon-cross"
          ></i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import AdaptiveTextArea from '@components/AdaptiveTextArea.vue'
import AdditionInfoMixins from '@apps/order-form/src/mixins/additionInfo'

export default {
  name: 'AdditionInfoComponent',

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },

  mixins: [AdditionInfoMixins],

  components: { AdaptiveTextArea },
}
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  overflow: hidden;

  transition: height 0.25s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  height: 0;
}

* {
  will-change: height;

  transform: translateZ(0);

  perspective: 1000px;
  backface-visibility: hidden;
}
</style>
